// extracted by mini-css-extract-plugin
module.exports = {"nav":"Nav_nav__3kBYp","navList":"Nav_navList__3zKg_","navLink":"Nav_navLink__FPkvB","currentNavLink":"Nav_currentNavLink__14bR1","mobileNav":"Nav_mobileNav__20Esn"};